import React from 'react';
import { PageHeader } from 'antd';
import history from '@utils/history';

import { PropertyEdit, PropertySider } from '@containers/properties';

import './CreateProperty.less';

function CreatePropertyPage() {
  return (
    <div className="properties main-page">
      <PageHeader
        title="New Property"
        style={{
          border: '1px solid rgb(235, 237, 240)'
        }}
        onBack={() => history.goBack()}
      />

      <div className="property main-content">
        <div className="property-sider">
          <PropertySider />
        </div>

        <div className="property-content">
          <PropertyEdit />
        </div>
      </div>
    </div>
  );
}

export default CreatePropertyPage;
